import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Fires a GA4 page_view on every SPA route change. The initial page_view
 * is already sent automatically by the gtag snippet in index.html.
 *
 * We strip query-strings BEFORE sending so personal context never reaches GA.
 * Even though our params are only `country=XX&lang=YY`, removing them keeps
 * the analytics surface area minimal and the privacy promise honest.
 */
export const useGAPageviews = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    const path = location.pathname; // intentionally drop search + hash
    try {
      window.gtag('event', 'page_view', {
        page_path: path,
        page_location: window.location.origin + path,
        page_title: document.title,
      });
    } catch (_e) { /* analytics never blocks the UI */ }
  }, [location.pathname]);
};

export default useGAPageviews;
